import { createSlice } from '@reduxjs/toolkit'

const slice = createSlice({
  name: 'auth',
  initialState: {
    getproviderProductList: [],
    getProviderProductListLoding: false,
    getProviderProductListPaginationData: {},
    updateProviderListLoding: false,

    getProductTypeList: [],
    getproductTypeListLoding: false,
    pharmacyBookingList: [],
    pharmacyBookingListLoading: false,
    pharmacyBookingPaginationData: {},
    getViewDetailsdata: [],
    getViewDetailsdataLoading: false,
    getViewBookingDetailsdata: [],
    getViewBookingDetailsdataLoading: false,
    getAppoimentStatusList: [],
    getAppoimentStatusListLoading: false,
    productListByProductType: [],
    productListByProductTypeLoading: false,
    productListByProductTypePaginationData: {},
    getAllTypePharmacyCategoriesLoading: false,
    getAllTypePharmacyCategoriesList: [],
    updateProductType: false,
    getPharmacySizes: [],
    getPharmacySizesListLoading: false,
    getListComposition: [],
    getListCompositionDataLoading: false,
    // updatePharmacyBookingList: false,
  },
  reducers: {
    getProductListByProviderData: (state) => {
      state.getProviderProductListLoding = true
    },
    getProductListByProviderDataSuccess: (state, { payload }) => {
      state.getProviderProductListLoding = false

      state.getproviderProductList = payload?.payload?.data
      state.getProviderProductListPaginationData = {
        rowCount: payload?.payload?.total,
        page: payload?.payload?.page,
        size: payload?.payload?.size,
        nextPage: payload?.payload?.next_page,
        previousPage: payload?.payload?.previous_page,
      }
    },
    getProductListByProviderDataFailed: (state, { payload }) => {
      state.getProviderProductListLoding = false
    },
    getProductListTypeApiData: (state, { payload }) => {},
    getProductTypeListApiDataSuccess: (state, { payload }) => {
      state.getProductTypeList = payload?.payload?.data
    },
    getProductTypeListApiDataFailed: (state, { payload }) => {},

    getPharmacyBookingOrderListApiData: (state, { payload }) => {
      state.pharmacyBookingListLoading = true
    },
    getPharmacyBookingOrderListApiSuccess: (state, { payload }) => {
      state.pharmacyBookingListLoading = false

      state.pharmacyBookingList = payload?.payload?.data
      state.pharmacyBookingPaginationData = {
        rowCount: payload?.payload?.total,
        page: payload?.payload?.page,
        size: payload?.payload?.size,
        nextPage: payload?.payload?.next_page,
        previousPage: payload?.payload?.previous_page,
      }
    },
    getPharmacyBookingOrderListApiFailed: (state, { payload }) => {
      state.pharmacyBookingListLoading = true
    },

    // view product Details
    getProductDeatilsApiData: (state, { payload }) => {
      state.getViewDetailsdataLoading = true
    },
    getProductDeatilsApisSuccess: (state, { payload }) => {
      state.getViewDetailsdataLoading = false
      state.getViewDetailsdata = payload?.payload?.data
    },
    getProductDeatilsApiFailed: (state, { payload }) => {},
    // View Booking Deatils Api data
    getBookingDeatilsApidata: (state, { payload }) => {
      state.getViewBookingDetailsdataLoading = true
    },
    getBookingDeatilsApiSuccess: (state, { payload }) => {
      state.getViewBookingDetailsdataLoading = false
      state.getViewBookingDetailsdata = payload?.payload?.data
    },
    getBookingDeatilsApiFailed: (state, { payload }) => {
      state.getViewBookingDetailsdataLoading = false
    },
    getAppointMentStatusApiData: (state, { payload }) => {
      state.getAppoimentStatusListLoading = true
    },
    getAppointMentStatusApiSuccess: (state, { payload }) => {
      state.getAppoimentStatusList = payload?.payload?.data
      state.getAppoimentStatusListLoading = false
    },
    getAppointMentStatusApiFailed: (state, { payload }) => {
      state.getAppoimentStatusListLoading = true
    },
    //Update order by pharmacy
    updatePharmacyBookingListApiData: (state, { payload }) => {
      state.updatePharmacyOrder = false
      state.pharmacyBookingList = state.pharmacyBookingList?.map((item) => {
        if (item?.id === payload?.id) {
          return { ...item, ...payload }
        } else {
          return item
        }
      })
    },
    updatePharmacyBookingListSuccess: (state, { payload }) => {
      state.updatePharmacyOrder = true
    },
    updatePharmacyBookingListFailed: (state, { payload }) => {},
    // product Listing by productType
    getProductListByProductTypeApiData: (state, { payload }) => {
      state.productListByProductTypeLoading = true
    },
    getProductListByProductTypeDataSuccess: (state, { payload }) => {
      state.productListByProductType = payload?.payload?.data
      state.productListByProductTypeLoading = false
      state.productListByProductTypePaginationData = {
        rowCount: payload?.payload?.total,
        page: payload?.payload?.page,
        size: payload?.payload?.size,
        nextPage: payload?.payload?.next_page,
        previousPage: payload?.payload?.previous_page,
      }
    },
    getProductListByProductTypeDataFailed: (state, { payload }) => {
      state.productListByProductTypeLoading = true
    },
    // get All Types Category
    getAllTypePharmacyCategoriesApiData: (state, { payload }) => {
      state.getAllTypePharmacyCategoriesLoading = true
    },
    getAllTypePharmacyCategoriesApiSucess: (state, { payload }) => {
      state.getAllTypePharmacyCategoriesLoading = false
      state.getAllTypePharmacyCategoriesList = payload?.payload?.data
    },
    getAllTypePharmacyCategoriesApiFailed: (state, { payload }) => {
      state.getAllTypePharmacyCategoriesLoading = true
    },

    // Add product category
    addProductByProductTypeApiData: (state, { payload }) => {
      state.updateProductType = false
    },
    addProductByProductTypeApiSucess: (state, { payload }) => {
      state.updateProductType = true
    },
    addProductByProductTypeApiFailed: (state, { payload }) => {
      state.updateProductType = false
    },

    // get Sizes
    getPharmacySizesApiData: (state, { payload }) => {
      state.getPharmacySizesListLoading = true
    },
    getPharmacySizesApiDataSuccess: (state, { payload }) => {
      state.getPharmacySizesListLoading = false
      state.getPharmacySizes = payload?.payload?.data
    },
    getPharmacySizesApiDataFailed: (state, { payload }) => {
      state.getPharmacySizesListLoading = true
    },

    // get List Composition
    getListCompositionApiData: (state, { payload }) => {
      state.getListCompositionDataLoading = true
    },
    getListCompositionDataSuccess: (state, { payload }) => {
      state.getListCompositionDataLoading = false
      state.getListComposition = payload?.payload?.data
    },
    getListCompositionDataFailed: (state, { payload }) => {
      state.getListCompositionDataLoading = false
    },
    // get List Sub Types Api Data
    getListSubTypesApiData: (state, { payload }) => {
      state.getSubTypeListLoading = true
    },
    getListSubTypesApiSuccess: (state, { payload }) => {
      state.getSubTypeListLoading = false
      state.getSubTypeList = payload?.payload?.data
    },
    getListSubTypesApiFailed: (state, { payload }) => {
      state.getSubTypeListLoading = true
    },
  },
})

export const {
  getProductListByProviderDataSuccess,
  getProductListByProviderDataFailed,
  getProductListByProviderData,

  // get Product Type
  getProductListTypeApiData,
  getProductTypeListApiDataSuccess,
  getProductTypeListApiDataFailed,

  // get booking Order List
  getPharmacyBookingOrderListApiData,
  getPharmacyBookingOrderListApiSuccess,
  getPharmacyBookingOrderListApiFailed,

  // view product Details
  getProductDeatilsApiData,
  getProductDeatilsApisSuccess,
  getProductDeatilsApiFailed,
  // View Booking Deatils Api data
  getBookingDeatilsApidata,
  getBookingDeatilsApiSuccess,
  getBookingDeatilsApiFailed,
  // appointment Status
  getAppointMentStatusApiData,
  getAppointMentStatusApiSuccess,
  getAppointMentStatusApiFailed,
  //Update order by pharmacy
  updatePharmacyBookingListApiData,
  updatePharmacyBookingListSuccess,
  updatePharmacyBookingListFailed,
  // product Listing by productType
  getProductListByProductTypeApiData,
  getProductListByProductTypeDataSuccess,
  getProductListByProductTypeDataFailed,
  // get All Types Category
  getAllTypePharmacyCategoriesApiData,
  getAllTypePharmacyCategoriesApiSucess,
  getAllTypePharmacyCategoriesApiFailed,

  // Add product category
  addProductByProductTypeApiData,
  addProductByProductTypeApiSucess,
  addProductByProductTypeApiFailed,

  // get Sizes
  getPharmacySizesApiData,
  getPharmacySizesApiDataSuccess,
  getPharmacySizesApiDataFailed,

  // get List Composition
  getListCompositionApiData,
  getListCompositionDataSuccess,
  getListCompositionDataFailed,

  // get List Sub Types Api Data
  getListSubTypesApiData,
  getListSubTypesApiSuccess,
  getListSubTypesApiFailed,
} = slice.actions

export default slice.reducer
